import { useState, useEffect } from "react";
import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./ScholarshipBanner.module.scss";
import ScholarshipIcon from "@Icons/ScholarshipIcon";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import CustomLink from "@Components/CustomLink";
//

const ScholarshipBanner = ({ isMobile = false }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const shouldShow = params.get("scholarship") === "true";
    setIsVisible(shouldShow);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={formatClassNames(styles.scholarshipBanner, isMobile && styles.mobile)}>
      <div className={styles.leftContent}>
        <div className={formatClassNames(styles.iconContainer, isMobile && styles.mobile)}>
          <ScholarshipIcon size={40} />
        </div>
        <div className={styles.textContainer}>
          <p className={styles.scholarshipText}>
            {"home.scholarshipbanner.title"}{" "}
            <span className={styles.liveText}>home.scholarshipbanner.titlered</span>
          </p>
          {!isMobile && (
            <p className={styles.offeringText}>
              {"home.scholarshipbanner.offeringtext"}{" "}
              <span className={styles.amountText}>home.scholarshipbanner.offeringtextother</span>
            </p>
          )}
        </div>
      </div>
      <CustomLink href="/scholarship" className={styles.knowMoreButton} isExternal>
        home.scholarshipbanner.knowmore
      </CustomLink>
    </div>
  );
};

export default wrapperHOC(ScholarshipBanner, {
  componentName: "ScholarshipBanner-Home",
  showForChina: true,
});
